export default __webpack_public_path__ + "static/media/audi.29a96f3e.jpg";